var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-success"}},[_c('div',{staticClass:"box",attrs:{"id":"container"}},[_vm._v("Produto adicionado com sucesso.")])])}]

export { render, staticRenderFns }